<template>
    
</template>

<script>
    export default {
        name: "SchoolTopbarSection",
        data () {
            return {
                sectionType: "school-topbar"
            }
        },
        computed: {
            myData () {
                return this.schoolTopbarData[this.topbarStatus];
            },
        },
        methods: {
             acquireSectionData () {
                if ( !this.schoolTopbarData[this.topbarStatus] || (this.schoolTopbarData[this.topbarStatus] && this.schoolTopbarData[this.topbarStatus].sectionId !== this.sectionId)) {
                    this.changeMyData(this.getDefaultDataStructure);
                } else if (!Object.keys(this.getDefaultDataStructure).every(key => typeof this.myData[key] !== "undefined") ) {
                    let updatedValues = {};

                    Object.keys(this.getDefaultDataStructure).forEach( key => {
                        let defaultValue = this.getDefaultDataStructure[key];
                        if (typeof this.myData[key] === "undefined") {
                            updatedValues[key] = defaultValue;
                        }
                    })

                    this.changeMyData(updatedValues);
                }
            },
        }
    }
</script>

